import styled from '@emotion/styled';
import { COLOR } from './styles';

export const Text = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: ${COLOR.font.base};
  text-align: center;
`;
